module.exports = __webpack_public_path__ + "assets/image-not-found.1dd26afbbc2c0e3b0aab24628e2f04f3.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/img/image-not-found.png
 ** module id = 909
 ** module chunks = 0
 **/